<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-select class="full-width" clearable v-model="valueSync" filterable :placeholder="placeholder">
        <el-option
                v-for="item in options"
                :key="item.value"
                :disabled="fanDisabled && fanValue === item.value"
                :label="item.cn_name"
                :value="item.value">
        </el-option>
    </el-select>
</template>

<script>
    import {USER_SELECTABLE_ROLES, ROLES, ROLE_VALUE_MAP} from '../../../constant/role';

    export default {
        name: '',
        props: {
            value: String | Number,
            placeholder: String,
            fanDisabled: {
                type: Boolean,
                default: false
            },
            withAdmin: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            options () {
                if (this.withAdmin) {
                    return ROLES;
                } else {
                    return USER_SELECTABLE_ROLES;
                }
            }
        },
        data () {
            return {
                valueSync: null,
                fanValue: ROLE_VALUE_MAP.FAN
            };
        },
        watch: {
            value (value) {
                this.valueSync = value;
            },
            valueSync (valueSync) {
                if (valueSync === '') {
                    this.valueSync = null;
                    return;
                }
                this.$emit('input', valueSync);
            }
        }
    };
</script>
